// extracted by mini-css-extract-plugin
export default {"slideContainer":"_51e8da7904 _8f2919e599 _863aa7abed","slideImage":"ba0f16a02c"};